import { useState, useEffect, useCallback, memo } from 'react'
import { VideoGrid } from './video-grid'
import { type VideoItem } from './video-card'
import { VideoModal, Loader } from '@/components/ui'

export function CommunityGallerySection() {
  const [videos, setVideos] = useState<VideoItem[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [selectedVideo, setSelectedVideo] = useState<VideoItem | null>(null)

  useEffect(() => {
    fetch('/videos.json')
      .then((res) => res.json())
      .then((data) => setVideos(data.videos))
      .catch(console.error)
      .finally(() => setIsLoading(false))
  }, [])

  // Memoize callbacks to prevent unnecessary re-renders of VideoGrid
  const handlePlay = useCallback((video: VideoItem) => {
    setSelectedVideo(video)
  }, [])

  const handleCloseModal = useCallback(() => {
    setSelectedVideo(null)
  }, [])

  return (
    <section>
      <SectionHeader />
      <div className="mt-6">
        {isLoading ? (
          <Loader text="Loading videos..." className="py-20" />
        ) : (
          <VideoGrid videos={videos} onPlay={handlePlay} />
        )}
      </div>

      {/* Video player modal */}
      <VideoModal
        isOpen={!!selectedVideo}
        onClose={handleCloseModal}
        videoUrl={selectedVideo?.videoUrl ?? ''}
        title={selectedVideo?.title ?? ''}
        dimensions={selectedVideo?.dimensions}
      />
    </section>
  )
}

const SectionHeader = memo(function SectionHeader() {
  return (
    <div>
      <h2 className="text-xl sm:text-2xl font-semibold text-white">
        See What Others Have Created
      </h2>
      <p className="text-[#666] mt-1">
        Get inspired by the community's creations
      </p>
    </div>
  )
})
